import { EvComboboxOption } from '@evinced-private/ui-common';

import { SCOPE_ACTIONS } from '../../../../types/scope/ScopeActions';

export const REMOVE_ISSUE_BUTTON_TITLE = 'Remove Issue Type Rule';
export const ACTION_LABEL = 'Action';
export const ACTION_PLACEHOLDER = 'Select Action';
export const SEVERITY_VALUE_LABEL = 'Severity';
export const SEVERITY_VALUE_PLACEHOLDER = 'Select Severity';

export const ISSUE_SEVERITIES_ACTIONS: EvComboboxOption[] = [
	{ label: 'Include Severities', value: SCOPE_ACTIONS.INCLUDE },
	{ label: 'Exclude Severities', value: SCOPE_ACTIONS.EXCLUDE }
];
